export default __webpack_public_path__ + "static/media/app1.0dd15e38.png";